import React, { ReactNode } from 'react';
import './SlideUpAnimation.scss';
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";

interface SlideUpAnimationProps {
    triggerOnce: boolean;
    rootMargin?: string;
    delay?: number;
    children: ReactNode;
}

export default function SlideUpAnimation(props: SlideUpAnimationProps): JSX.Element {
    const [ref, inView] = useInView({
        triggerOnce: props.triggerOnce,
        rootMargin: props.rootMargin || '0% 0px'
    });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 100 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1, ease: 'easeOut', delay: props.delay || 0 }}
        >
            {props.children}
        </motion.div>
    );
}